import React from "react";
import { Text } from './Themed';
import Fonts from '../constants/Fonts';

export default function ListHeader({ title = '' }) {
    return <Text style={{ ...Fonts.hero, paddingVertical: 24, paddingHorizontal: 12 }}>{title.toUpperCase()}</Text>
}